import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
const urlPrefix = "/plugins/org.graylog.plugins.datatiering/datatiering/repositories";
const DATA_TEARING_READINESS_KEY = "data_tiering_ready";
const getReadiness = () => fetch("GET", qualifyUrl(`${urlPrefix}/readiness`));
const useDataTiering = () => {
  const { data, isLoading } = useQuery({
    queryKey: [DATA_TEARING_READINESS_KEY],
    queryFn: () => defaultOnError(
      getReadiness(),
      "Fetching Data Tiering readiness failed with status",
      "Could not fetch Data Tiering readiness."
    )
  });
  return {
    readiness: {
      data,
      isLoading
    }
  };
};
export default useDataTiering;
